import Swal from "sweetalert2";
import SweetAlert from "sweetalert2";
import { fetchError, TIMEOUT } from "./utils";
const Toast = SweetAlert.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', SweetAlert.stopTimer);
        toast.addEventListener('mouseleave', SweetAlert.resumeTimer);
    }
});
export const cartAddSuccessCallback = (cart, reference, action) => {
    if (action == 'add') {
        if (window.add_to_cart_mode == 'popup') {
            let tplalert = document.getElementById('tpl-add-to-cart');
            if (tplalert) {
                let alert_addtocart = Handlebars.compile(tplalert.innerHTML);
                let dataId = document.querySelector('#ID' + reference.id);
                if (dataId) {
                    let ctx = JSON.parse(dataId.value);
                    console.log(ctx);
                    window.safePopup = true;
                    Swal.fire({
                        template: 'add-to-cart-template',
                        html: alert_addtocart(ctx),
                        showCancelButton: false,
                        showConfirmButton: true,
                        timerProgressBar: true,
                        timer: window.ADD_TO_CART_POPUP_TIMER,
                        didClose: () => {
                            window.safePopup = false;
                            // clearInterval(timerInterval);
                            // $('#header_cart_container #header_cart').addClass('heartBeat animate');
                        }
                    }).then((result) => {
                        window.safePopup = false;
                        console.log(result);
                    });
                    return;
                }
            }
        }
        window.safePopup = true;
        Toast.fire({
            icon: 'success',
            title: window.add_to_cart_success_text,
            showCancelButton: false,
            showConfirmButton: false,
            timerProgressBar: true,
            timer: window.ADD_TO_CART_POPUP_TIMER,
            customClass: {
                popup: 'my-toast'
            },
            didClose: () => {
                window.safePopup = false;
                // clearInterval(timerInterval);
                // $('#header_cart_container #header_cart').addClass('heartBeat animate');
            }
        }).then((result) => {
            window.safePopup = false;
            console.log(result);
        });
    }
};
export const loadingPage = () => {
    console.log('loadingPage');
    SweetAlert.fire({
        title: '',
        html: '',
        showCancelButton: false,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        customClass: { container: 'swal-transparent' },
        didOpen: () => {
            //SweetAlert.showLoading();
        }
    });
};
export const cartAddErrorCallback = () => {
    console.log('cartAddErrorCallback');
    Toast.fire({
        icon: 'error',
        title: 'No se ha podido agrear el producto al carrito'
    });
};
export const userProfileUpdated = () => {
    console.log('userProfileUpdated');
    Toast.fire({
        icon: "success",
        title: "Su perfil se ha actualizado"
    });
};
export const userProfileSendActivation = () => {
    console.log('userProfileSendActivation');
    Toast.fire({
        icon: "success",
        title: "El correo de verificación fue enviado."
    });
};
export const userProfileUpdatedError = () => {
    Toast.fire({
        icon: "error",
        title: "No se ha podido actualizar su perfil"
    });
};
export const validateReserve = (form_data, onsuccess) => {
    SweetAlert.fire({
        title: 'Validando Reserva',
        allowEscapeKey: false,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: false,
        timer: 5000,
        willOpen: () => {
            SweetAlert.showLoading();
            setTimeout(SweetAlert.clickConfirm, 0);
        },
        preConfirm: (login) => {
            // @ts-ignore
            let signal = AbortSignal.timeout(TIMEOUT);
            return fetch(`${window.API_URL}/api/cart/validate_reserve/`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: "include",
                body: JSON.stringify({ 'data': form_data }),
                signal: signal
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            }).catch(error => {
                fetchError(error);
                SweetAlert.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: 'Validación Fallida',
                    icon: 'error',
                    text: 'No hemos podido validar su reserva, verifique que los datos sean correctos',
                    showConfirmButton: true,
                });
            });
        },
        allowOutsideClick: () => !SweetAlert.isLoading()
    }).then((result) => {
        if (result.isConfirmed) {
            let result_content = result.value;
            result_content = result_content.replace(/\r\n/g, '<br>');
            result = JSON.parse(result_content);
            if (!result.success) {
                throw new Error(result.message);
            }
            localStorage.setItem("BOOKING_DATA", JSON.stringify(result));
            onsuccess(result);
        }
    }).catch(error => {
        SweetAlert.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            title: 'Validación Fallida',
            icon: 'error',
            html: `No hemos podido validar su reserva, verifique que los datos sean correctos<br><em><strong>${error.message}</strong></em>`,
            showConfirmButton: true,
        });
    });
};
export const openLoading = function () {
    console.log('start loading...');
    loadingPage();
    // Swal.showLoading()
};
export const closeLoading = function () {
    console.log('close loading...', window.safePopup);
    if (window.safePopup) {
        return;
    }
    Swal.close();
    console.log('closed...');
};
export const sendOrder = function () {
    Swal.fire({
        title: '!Espere por favor!',
        html: '',
        timer: 10000,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        willOpen: () => {
            Swal.showLoading();
        },
    });
};
